// Payloads, URLs and one-time signing keys remain local to their authorized view.
export function skipWebhookStore(context) {
  if (['webhooks', 'webhook-queue', 'webhook-logs'].includes(context.path)) context.params.skipStore = true
  return context
}
